import { useQuery } from '@tanstack/react-query';
import { paymentApi } from '../api/payment.api';
import type { AffairePaymentStatsEnhanced } from '../types/payment.types';

// Re-export for backward compatibility
export type AffairePaymentStats = AffairePaymentStatsEnhanced;

export const useAffairePaymentStats = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['affaire-payment-stats'],
    queryFn: paymentApi.getAffairePaymentStats,
    staleTime: 30000, // Consider data fresh for 30 seconds
    refetchOnWindowFocus: false
  });

  return {
    stats: data?.data || {} as Record<string, AffairePaymentStatsEnhanced>,
    isLoading,
    error,
    refetch
  };
};
